var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"toggle",attrs:{"type":"button"},on:{"click":_vm.openSettings}},[_vm._v(" "+_vm._s(_vm.$t('WEBAPP_PRIVACY_CONSENT_MANAGEMENT_TITLE'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }